export const PRESETS_CODES = {
	FAVORITE_LINKS: 'app-favorite-links-settings',
	PERSONAL_SETTINGS_START_DAY: 'app-personal-settings-start-day',
	PERSONAL_SETTINGS_SINGLE_TEST: 'app-personal-settings-single-test',
	PERSONAL_SETTINGS_MULTIPLE_TEST: 'app-personal-settings-multiple-test',
}

export const CONFLICT_POLICY_TO_CLONING_PRESET = {
	ADD_IF_NOT_EXISTS: 'add_if_not_exists',
	REPLACE_ALL: 'replace_all',
}

/* указывать в формате p{short_view}_{short_group}_{short_module}. ex: pt_cp_cs */
const TABLE_PRESETS_CODES = {
	CROP_PRODUCTION_CROPS_STRUCTURE_TABLE: 'pt_cp_cs',
	CROP_PRODUCTION_TECHNOLOGICAL_CARDS: 'pt_cp_tc',
	MY_TASKS_NOTIFICATIONS: 'pt_mt_n',
	CONTROL_EVENTS: 'pt_c_e',
	WORKS_IN_FIELD_ALL_FIELD_WORKS: 'pt_wf_fw',
	WORKS_IN_FIELD_OPERATIONAL_PLAN: 'pt_wf_op',
	LOGISTICS_WAYBILLS: 'pt_l_w',
	ALL_WORKS_DYNAMIC_TABLE_CODE: 'pt_aw_d',
	ALL_WORKS_REPORTING_TABLE_CODE: 'pt_aw_r',
	ALL_WORKS_QUALITY_TABLE_CODE: 'p_awq_tc',
	ALL_WORKS_RESOURCE_CONSUMPTION_TABLE_CODE: 'pt_aw_rc',
	ALL_WORKS_PRODUCTS_TABLE_CODE: 'pt_aw_p',
	ALL_WORKS_CROP_WRITEOFFS: 'pt_aw_cw',
	GPS_MONITORING_MOVEMENTS: 'pt_gps_m',
	TECHNIQUE_AND_EQUIPMENT_TECHNIQUE: 'pt_te_t',
	TECHNIQUE_AND_EQUIPMENT_EQUIPMENT: 'pt_te_e',
	TECHNIQUE_AND_EQUIPMENT_DEVICES_AND_SENSORS: 'pt_te_ds',
	TECHNIQUE_AND_EQUIPMENT_IDENTIFIERS: 'pt_te_i',
	TECHNIQUE_AND_DEVICES_FUEL_BY_DEVICES: 'p_td_fbd_tc',
	TECHNIQUE_AND_DEVICES_REFUELING: 'p_td_r_tc',
	TECHNIQUE_AND_DEVICES_DEVICE_MOUNTING: 'p_td_dm_tc',
	TECHNIQUE_AND_DEVICES_MACHINERY_WRITEOFFS: 'pt_td_mw',
	INVENTORY_CONTROL_WEIGH_INS: 'p_ic_wi_tc',
	INVENTORY_CONTROL_UNLOADING_HARVESTERS: 'pt_ic_uh',
	INVENTORY_CONTROL_RECEIPTS_AND_SHIPMENTS: 'pt_ic_ras',
	INVENTORY_CONTROL_GRAIN_LAB_SAMPLES: 'pt_ic_gls',
	INVENTORY_CONTROL_WAYBILLS_REGISTRY: 'pt_ic_wr',
	INVENTORY_CONTROL_ELEVATOR_BALANCES: 'pt_ic_eb',
	ECONOMY_EMPLOYEE_ACCRUALS: 'pt_e_ea',
	REAL_ESTATE_WEIGHT_COMPLEXES: 'pt_re_wc',
	LAND_BANK_FIELDS: 'pt_lb_f',
	LAND_BANK_LAND: 'pt_lb_l',
	LAND_BANK_DOCUMENTS: 'pt_lb_d',
	COMPANY_SETTINGS_TELEMETRY_SOURCES: 'pt_cs_ts',
}

Object.freeze(TABLE_PRESETS_CODES)

const DASHBOARD_PRESETS_CODES = {
	INVENTORY_CONTROL_WEIGH_INS: 'pd_ic_wi',
	WORKS_IN_FIELD_ALL_FIELD_WORKS: 'pd_wf_fw',
}

Object.freeze(DASHBOARD_PRESETS_CODES)

const PRESET_GRID_SETTINGS_TYPES = {
	DEFAULT: 'default',
}

Object.freeze(PRESET_GRID_SETTINGS_TYPES)

export {
	TABLE_PRESETS_CODES,
	DASHBOARD_PRESETS_CODES,
	PRESET_GRID_SETTINGS_TYPES,
}
